<template>
  <div>
    <div class="return-record-info">
      <crm-button
        :buttonType="'plain'"
        size="mini"
        text="导出"
        class="fr mb10"
        :disabled="isExportDisabled"
        @click="handleExport"
      >
      </crm-button>
      <crm-button
        :size="'mini'"
        :text="'新增费用'"
        class="fr mb10"
        @click="handleAddPay"
      >
      </crm-button>
    </div>
    <el-table
      :data="payDataList.results"
      :loading="addPayDialog.payLoading"
      style="width: 100%; height: calc(100vh - 395px);"
    >
      <el-table-column prop="fee" label="费用(元)" align="center">
      </el-table-column>
      <el-table-column prop="feeDate" label="产生日期" width="100" align="center">
      </el-table-column>
      <el-table-column prop="feeTypeName" label="费用类型" align="center">
      </el-table-column>
      <el-table-column prop="payee" label="收款方" width="180" align="center">
      </el-table-column>
      <el-table-column
        prop="remarks"
        show-overflow-tooltip
        label="备注"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="creator" label="创建人" align="center">
      </el-table-column>
      <el-table-column
        prop="gmtCreated"
        label="创建时间"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="
                      contractAuth.contractFeeUpdate &&
                      contractAuth.contractFeeUpdate.toggleStatus
                    "
            @click="handleUpdatePay(scope)"
            type="text"
            size="small"
          >
            编辑
          </el-button>
          <el-button
            v-if="
                      contractAuth.contractFeeDelete &&
                      contractAuth.contractFeeDelete.toggleStatus
                    "
            @click="handleDeletePay(scope)"
            type="text"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pay.pageNumber"
        :page-sizes="[5, 10, 20]"
        :page-size="pay.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="payDataList.totalCount"
      >
      </el-pagination>
    </div>
    <!-- 费用弹窗 -->
    <el-dialog
      @title="addPayDialog.type === 'eidt' ? '编辑费用' : '新增费用'"
      :visible.sync="addPayDialog.visible"
      width="50%"
      append-to-body
    >
      <add-pay
        v-if="addPayDialog.visible"
        :type="addPayDialog.type"
        :compactId="id"
        :payDetail="addPayDialog.payDetail"
        @close="addPayDialog.visible = false"
        @success="queryList()"
      >
      </add-pay>
    </el-dialog>
  </div>
</template>

<script>
import CrmButton from "~component/base/crmButton";
import { mapActions, mapGetters } from 'vuex'
import AddPay from "./AddPay.vue";
import config from '~config'
import { newDownloadByUrl } from '@/scripts/utils'

export default {
  components: {
    CrmButton,
    AddPay,
  },
  filters: {},
  props: {
    id: String,
  },
  data() {
    return {
      // 新增编辑费用
      addPayDialog: {
        visible: false,
        type: "add",
        payLoading: false,
        payDetail: {},
      },
      pay: {
        pageNumber: 1,
        pageSize: 5,
      },
      isRefresh: false,
      isExportDisabled: false,
    }
  },
  computed: {
    ...mapGetters({
      contractAuth: "authority/contractAuth",
      compactDetail: "compact/compactDetail",
      payDataList: "compact/payDataList",
    }),
  },
  watch: {},
  methods: {
    ...mapActions({
      deleteCompactFee: "compact/deleteCompactFee",
      getPayDataList: "compact/getPayDataList",
      getCompactDetail: "compact/getCompactDetail",
    }),
    handleGetPayList() {
      this.addPayDialog.payLoading = true;
      const { pageSize, pageNumber } = this.pay;
      this.getPayDataList({
        contractId: this.id,
        pageSize,
        pageNumber,
      }).finally(() => {
        if (this.payDataList?.results.length === 0 && pageNumber !== 1) {
          this.pay.pageNumber = 1;
          this.handleGetPayList();
        } else {
          this.addPayDialog.payLoading = false;
        }
      });
    },
    handleSizeChange(value) {
      this.pay.pageNumber = 1
      this.pay.pageSize = value
      this.queryList()
    },
    handleCurrentChange(value) {
      this.pay.pageNumber = value
      this.queryList()
    },
    // 费用-导出
    handleExport() {
      this.isExportDisabled = true;
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在导出中，请稍后...",
        duration: 0,
        showClose: false,
      });
      const url = `${config.api || ""}/api/crmcontract/download/fee?contractId=${this.id}`;
      newDownloadByUrl(url, "get").finally(() => {
        this.isExportDisabled = false;
        this.notify.close();
      });
    },
    // 新增费用
    handleAddPay() {
      this.addPayDialog.visible = true;
      this.addPayDialog.type = "add";
    },
    // 编辑费用
    handleUpdatePay(scope) {
      this.addPayDialog.payDetail = scope.row;
      this.addPayDialog.visible = true;
      this.addPayDialog.type = "edit";
    },
    // 删除费用
    handleDeletePay(scope) {
      this.$confirm("是否确定删除该费用？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteCompactFee({ id: scope.row.id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.pay.pageNumber = 1
            this.queryList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 更改了费用之后刷新数据
    queryList() {
      this.handleGetPayList();
      this.isRefresh = true;
      this.getCompactDetail({ id: this.id });
    },
  },
}
</script>
